import { render, staticRenderFns } from "./Chapter_show.vue?vue&type=template&id=3d5a32d8&scoped=true&"
import script from "./Chapter_show.vue?vue&type=script&lang=js&"
export * from "./Chapter_show.vue?vue&type=script&lang=js&"
import style0 from "./Chapter_show.vue?vue&type=style&index=0&id=3d5a32d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a32d8",
  null
  
)

export default component.exports